import * as React from 'react';

var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    stroke: "#fff",
    strokeWidth: 2,
    d: "M29 15c0 7.732-6.268 14-14 14S1 22.732 1 15 7.268 1 15 1s14 6.268 14 14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M19.235 10.687a.64.64 0 01-.006.89l-3.371 3.399 3.456 3.444a.638.638 0 01.01.89.606.606 0 01-.871.011L14.98 15.86l-3.43 3.459a.608.608 0 01-.872-.006.638.638 0 01.005-.89l3.415-3.442-3.412-3.401a.638.638 0 01-.01-.89.606.606 0 01.871-.011l3.428 3.417 3.388-3.415a.608.608 0 01.872.006z",
    clipRule: "evenodd"
  })));
}

export { SvgError as ReactComponent };
//# sourceMappingURL=Error.svg.js.map
